import React from 'react'
import {
  BlogStartYourDesignBannerContainer,
  CtaButton
} from './BlogStartYourDesignBanner.styles'
import softImg from '../../assets/blog/sofa-big.png'

export const BlogStartYourDesignBanner = () => {
  return (
    <BlogStartYourDesignBannerContainer>
      <h2>Start Your Design</h2>
      <p>Design your dream home at your fingertips.</p>
      <img src={softImg} alt="" />
      <CtaButton href="http://decormatters.app.link/blog">Let’s Go</CtaButton>
    </BlogStartYourDesignBannerContainer>
  )
}
